import { ApiContext } from '../../types'
import getCurrentBearerOrCartToken from '@/api_client/api/authentication/getCurrentBearerOrCartToken'
import { deserializeAttendanceLog } from '@/api_client/api/serializers/attendance_record'

export default async function getAttendanceLogs(
  { client, config }: ApiContext,
  params,
) {
  try {
    const token = await getCurrentBearerOrCartToken({ client, config })
    const result = await client.attendanceRecords.show(token, {
      ...params,
      sort: params.sort ?? '-id',
      per_page: params.per_page ?? 10,
    })
    if (result.isSuccess()) {
      const payload = result.success()

      // console.log(payload)
      // cons
      const data = payload.data.map((e) =>
        deserializeAttendanceLog(e, payload.included),
      )

      return {
        data: data,
        meta: payload.meta,
      }
    } else {
      // console.log('not success');
      console.log(result.fail())
      return null
    }
  } catch (e) {
    console.error('getShipments:', e)
    // throw e;
    return null
  }
}
